module.exports = __webpack_public_path__ + "img/泛思特海运办公室(1).c5cf74d6.jpg";